module.exports = __webpack_public_path__ + "img/gs.e28830d9.webp";